var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DescriptionSection',[_c('DescriptionItem',{attrs:{"title":"Numer lokomotywy","value":_vm.service.locomotives[0].sideNumber}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }